/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentCallCreateBodyParams } from '../models/AgentCallCreateBodyParams';
import type { Call } from '../models/Call';
import type { CallGetResponse } from '../models/CallGetResponse';
import type { CallListResponse } from '../models/CallListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V2CallsService {
    /**
     * Get a single call by ID
     *
     * Retrieves basic call information without transcription and analysis data
     * @param id
     * @returns CallGetResponse Ok
     * @throws ApiError
     */
    public static getCall(
        id: number,
    ): CancelablePromise<CallGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/calls/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Not found.`,
            },
        });
    }
    /**
     * Get a paginated list of calls
     *
     * Retrieves basic call information without transcription and analysis data
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @param tenantId
     * @returns CallListResponse Ok
     * @throws ApiError
     */
    public static getCalls(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
        tenantId?: string,
    ): CancelablePromise<CallListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/calls',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Not found.`,
                422: `Search validation or database work budget exceeded.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Call Ok
     * @throws ApiError
     */
    public static startAgentCall(
        requestBody: AgentCallCreateBodyParams,
    ): CancelablePromise<Call> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/calls/start/agent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Configuration error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
}
